module.exports = angular;


/*****************
 ** WEBPACK FOOTER
 ** external "angular"
 ** module id = 195
 ** module chunks = 0
 **/